module.exports = __webpack_public_path__ + "img/Nachos Icon - charcoal.f14d5efa.svg";